import { useStateUtils } from '@/utils/deviceUtils/utils';
import { useDictUtil } from '@/utils/useDictUtils';

// 0--停止 1--启动中 2--检测中 3-保持中 4-自净中
export const HT200StatusUtil = useStateUtils({
  namespace: 'HT200Status',
  options: [
    {
      state: 0,
      text: '停止',
      code: 'is-stop',
      color: '#009898'
    },
    {
      state: 1,
      text: '检测中',
      code: 'is-starting',
      color: '#009898'
    },
    {
      state: 2,
      text: '检测中',
      code: 'is-detecting',
      color: '#009898'
    },
    {
      state: 3,
      text: '保持中',
      code: 'is-holding',
      color: '#009898'
    },
    {
      state: 4,
      text: '自净中',
      code: 'is-alarm',
      color: '#009898'
    }
  ]
});

export const alarmDict = useDictUtil({
  options: [
    { key: '103', text: '化学战剂', icon: 'icon-chemical-weapon', color: '#e94239' },
    { key: '104', text: '有毒有害气体', icon: 'icon-dupin', color: '#e94239' },
    { key: '111', text: '毒剂报警', icon: 'icon-dupin', color: '#e94239' },
    { key: '199', text: '模拟剂', icon: 'icon-simulation-agent', color: '#f7d151' }
  ]
});

export const fieldDict = useDictUtil({
  options: [
    {
      key: 0,
      text: '正模式'
    },
    {
      key: 1,
      text: '负模式'
    },
    {
      key: 2,
      text: '交替模式'
    }
  ]
});

export function makeLineOptions() {
  return {
    textStyle: {
      color: '#04a4bc'
    },
    tooltip: {
      trigger: 'axis'
    },
    dataZoom: [{ type: 'inside' }],
    backgroundColor: '#121e2c',
    legend: {
      top: 10,
      right: 10,
      textStyle: {
        color: '#04a4bc'
      }
    },
    grid: {
      top: 70,
      bottom: 30,
      left: 25,
      right: 35,
      containLabel: true
    },
    xAxis: {
      type: 'time',
      axisLine: {
        lineStyle: {
          color: '#172749'
        }
      },
      axisLabel: {
        fontSize: '90%'
      },
      splitLine: { show: false },
      axisTick: { show: false }
    },
    yAxis: {
      type: 'value',
      name: '',
      nameGap: 32,
      axisLine: { show: false },
      splitLine: {
        lineStyle: {
          color: '#172749'
        }
      },
      axisLabel: {
        fontSize: '90%'
      }
    },
    series: [
      {
        type: 'line',
        smooth: false,
        symbol: 'circle',
        data: []
      }
    ]
  };
}
